export default __webpack_public_path__ + "static/logo-45a369ec01089efd5bb734a19b01dae2.svg";